import { useQuery } from '@tanstack/react-query';
import { notificationCenterApi } from '../api/notificationCenterApi';
import type { NotificationHistorySearchCondition } from '../types/notificationCenter';

/**
 * GET /api/eraf/notification-center/history — 발송 이력 목록 (NOTIFICATION_READ)
 * queryKey: ['notification-center', 'list', filters]
 */
export function useNotificationHistory(filters: NotificationHistorySearchCondition) {
  return useQuery({
    queryKey: ['notification-center', 'list', filters],
    queryFn: () => notificationCenterApi.listHistory(filters),
    staleTime: 30_000,
  });
}
